import { bbAxios } from '@bb/session-manager';

import { WEBHOOK_EXPORT_CONTRACT_ENDPOINT } from '../endpoints.config';

export async function submitContractExportWebhook(id) {
  const { data } = await bbAxios.post(WEBHOOK_EXPORT_CONTRACT_ENDPOINT(id));
  return data;
}
